import { isChecked, PATHS } from '@belong/common';
import { CheckboxField, Link } from '@belong/ui';
import { AUTH_STRINGS } from 'src/features/auth/strings';

export const SMS_CONSENT_FIELD_NAME = 'smsConsent';

export function SmsConsentField() {
  return (
    <CheckboxField
      fontWeight="regular"
      inputContainerClass="self-start mt-2xs"
      label={
        <>
          {AUTH_STRINGS['sms.consent.line1']}
          <br />
          {AUTH_STRINGS['sms.consent.line2']}{' '}
          <Link href={PATHS.PRIVACY_POLICY} target="_blank" variant="text">
            {AUTH_STRINGS['terms.privacy']}
          </Link>{' '}
          {AUTH_STRINGS['terms.and']}{' '}
          <Link href={PATHS.TERMS} target="_blank" variant="text">
            {AUTH_STRINGS['terms.tos']}
          </Link>
          .
        </>
      }
      name={SMS_CONSENT_FIELD_NAME}
      size="small"
      validate={isChecked}
    />
  );
}
